import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { FactureCoproprietaireService } from '@service/syndic/facture-coproprietaire.service';
import { Globals } from '@theme/utils/globals';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { FactureCoproprietaireAddComponent } from '../facture-coproprietaire-add/facture-coproprietaire-add.component';

@Component({
  selector: 'app-facture-coproprietaire-list',
  templateUrl: './facture-coproprietaire-list.component.html',
  styleUrls: ['./facture-coproprietaire-list.component.scss']
})
export class FactureCoproprietaireListComponent implements OnInit {
  @Input() factures: any[] = [];
  @Input() trusteeUuid: string = '';
  dtOptions: any = {};

  constructor(
    private modalService: NgbModal,
    private emitter: EmitterService,
    private factureService: FactureCoproprietaireService
  ) {
    this.emitter.event.subscribe((data: any) => {
      if (data.action === 'FACTURE_COPRO_ADD' || data.action === 'FACTURE_COPRO_UPDATED') {
        this.loadData();
      }
    });
  }

  ngOnInit(): void {
    this.dtOptions = Globals.dataTable;
    this.loadData();
  }

  loadData(): void {
    if (this.trusteeUuid) {
      this.factureService.getList(this.trusteeUuid).subscribe((res: any) => {
        this.factures = res || [];
      });
    }
  }

  addFacture(): void {
    this.factureService.edit = false;
    this.factureService.setFactureCoproprietaire(null);
    this.modal(FactureCoproprietaireAddComponent, 'modal-basic-title', 'lg');
  }

  editFacture(row: any): void {
    this.factureService.edit = true;
    this.factureService.setFactureCoproprietaire(row);
    this.modal(FactureCoproprietaireAddComponent, 'modal-basic-title', 'lg');
  }

  deleteFacture(item: any): void {
    Swal.fire({
      title: 'Êtes-vous sûr ?',
      text: 'Cette action est irréversible !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, supprimer !',
      cancelButtonText: 'Non, annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.factureService.getDelete(item.uuid).subscribe((res: any) => {
          if (res?.status === 'success') {
            this.loadData();
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        });
      }
    });
  }

  modal(component: any, type: string, size: string): void {
    const modalRef = this.modalService.open(component, {
      ariaLabelledBy: type, size: size, centered: true, backdrop: 'static'
    });
    modalRef.result.then((result) => {}, (reason) => {});
  }
}
